if (!customElements.get('lm-workspace')) {
  class LMWorkspace extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.points = Array.from(this.querySelectorAll('[data-point]'));
      this.cards = Array.from(this.querySelectorAll('[data-product-card]'));
      this.detail = this.querySelector('.lmws-detail');
      this.controller = new AbortController();
      this.points.forEach(point => {
        point.addEventListener('click', event => { event.preventDefault(); this.select(point.dataset.point); }, {signal: this.controller.signal});
        point.addEventListener('keydown', event => {
          if (event.key === ' ') { event.preventDefault(); this.select(point.dataset.point); }
        }, {signal: this.controller.signal});
      });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('[data-product-card]');
        if (card) this.select(card.dataset.productCard);
      }, {signal: this.controller.signal});
      this.classList.add('lmws-ready');
      if (this.cards.length) this.select(this.cards[0].dataset.productCard, false);
    }
    select(id, announce = true) {
      const card = this.cards.find(item => item.dataset.productCard === id);
      if (!card) return;
      this.points.forEach(point => point.setAttribute('aria-pressed', String(point.dataset.point === id)));
      this.cards.forEach(item => item.classList.toggle('is-active', item === card));
      if (this.detail) {
        const copy = card.cloneNode(true);
        copy.removeAttribute('id'); copy.removeAttribute('data-product-card'); copy.removeAttribute('tabindex'); copy.removeAttribute('data-shopify-editor-block');
        copy.querySelectorAll('[id]').forEach(el => el.removeAttribute('id'));
        this.detail.replaceChildren(copy);
      }
      if (announce && window.matchMedia('(max-width: 999px)').matches) {
        this.querySelector('[data-scene-status]').textContent = card.querySelector('h3').textContent.trim();
      }
    }
    disconnectedCallback() { this.controller?.abort(); this.ready = false; }
  }
  customElements.define('lm-workspace', LMWorkspace);
}
